export const userStates = {
  enabled: "Enabled",
  disabled: "Disabled"
};
